import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { gispertSection4 } from '../utils/gispertContent4';
import { gispertSection4En } from '../utils/gispertContent4En';
import { getRelatedSectionsForGispert } from '../utils/relatedSections';
import RelatedSections from './RelatedSections';
import ContentGate from './ContentGate';

const Gispert4 = () => {
  const { t, i18n } = useTranslation();
  const content = i18n.language === 'en' ? gispertSection4En : gispertSection4;
  const [isUnlocked, setIsUnlocked] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('spain_project_unlocked') === 'true') {
      setIsUnlocked(true);
    }
  }, []);


  return (
    <div className='TesisPage TesisPage--gispert'>
      <aside className='TesisPage-rail'>
        <RelatedSections items={getRelatedSectionsForGispert('/Gispert4')} />
      </aside>
      <h1 className='TesisPageTitle'>{t('gispert4.title')}</h1>
      <h2 className='TesisPageSubtitle'>{t('gispert4.subtitle')}</h2>
      <article className='TesisPageContent'>
        {isUnlocked ? (
          <>
            {content.map((p, i) => <p key={i}>{p}</p>)}
          </>
        ) : (
          <ContentGate onUnlocked={() => setIsUnlocked(true)} />
        )}
      </article>
    </div>
  );
};

export default Gispert4;
